/**
 * All user-facing strings for the Eggs Fighting Game.
 * No text is hardcoded in JSX — every string comes from here.
 */
export const UI_STRINGS = {
  title: {
    main: 'EGGS',
    highlight: 'FIGHTING',
    subtitle:
      'A place where you can build your own style and flex it every day with your cool pants kek',
  },

  roles: {
    attacker: 'ATTACKER',
    defender: 'DEFENDER',
    yourEgg: 'YOUR EGG',
    enemyEgg: 'ENEMY EGG',
  },

  readyScreen: {
    instruction: 'PRESS THE KEY TO START THE DUEL',
    readyCount: (n: number) => `${n} / 2 READY`,
  },

  countdown: {
    fight: 'FIGHT!',
  },

  roundResult: {
    winsRound: 'WINS THE ROUND!',
  },

  winScreen: {
    suffix: 'WINS!',
    loserSubtext: 'BETTER LUCK NEXT TIME',
  },

  loseScreen: {
    suffix: 'WINS!',
    localSubtext: 'BETTER LUCK NEXT TIME',
  },

  tieScreen: {
    title: 'TIE!',
    subtext: 'SAME NUMBER OF WINS',
  },

  score: {
    vs: 'VS',
  },

  aria: {
    closeButton: 'Close game',
    eggImage: (name: string) => `${name}'s egg`,
  },
} as const;
